<template>
	<div class="text-center">
		<v-menu offset-y>
			<template #activator="{ on, attrs }">
				<v-btn
					:outlined="outlined"
					id="idButtonMenuAcoes"
					:color="corDeFundo"
					:block="block"
					:icon="!nomeBotao"
					:disabled="disabled"
					v-bind="!disabled ? attrs : null"
					v-on="!disabled ? on : null"
				>
					<v-icon v-show="iconePrimary" :size="tamanhoIconePrimary" :color="corIconePrimary"
						>{{ iconePrimary }}
					</v-icon>

					<div v-show="nomeBotao" class="ml-1 mr-1 texto-botao">
						{{ nomeBotao }}
					</div>

					<v-icon v-show="iconeSecondary" :size="tamanhoIconeSecondary" :color="corIconeSecondary">
						{{ iconeSecondary }}
					</v-icon>
				</v-btn>
			</template>

			<v-list dense>
				<v-list-item-group>
					<v-list-item
						v-for="acao in acoesMenu"
						v-show="acao.isVisible == null || acao.isVisible()"
						:id="acao.id"
						:key="acao.id"
						v-az-auth="acao.authorization"
						:disabled="acao.isDisabled != null && acao.isDisabled()"
						:data-testid="acao.evento"
						class="list-item-height"
						@click="$emit(acao.evento)"
					>
						<v-list-item-icon v-if="acao.icone">
							<v-icon :color="acao.icone.cor" :size="tamanhoIconeMenu" class="mr-2"
								>{{ acao.icone.nome }}
							</v-icon>
						</v-list-item-icon>
						<v-list-item-content>
							<v-list-item-title class="texto-menu-interno">{{ acao.titulo }}</v-list-item-title>
						</v-list-item-content>
					</v-list-item>
				</v-list-item-group>
			</v-list>
		</v-menu>
	</div>
</template>
<script>
export default {
	name: 'menu-acoes',
	props: {
		nomeBotao: {
			type: String,
			default: '',
		},
		corDeFundo: {
			type: String,
			default: 'primary',
		},
		acoesMenu: {
			type: Array,
			default() {
				return [
					{
						id: '',
						titulo: '',
						icone: {
							nome: '',
							cor: '',
						},
						evento: function () {},
						isDisabled: () => false,
						isVisible: () => false,
						authorization: '',
					},
				]
			},
		},
		corIconePrimary: {
			type: String,
			default: '',
		},
		corIconeSecondary: {
			type: String,
			default: '',
		},
		iconePrimary: {
			type: String,
			default: '',
		},
		iconeSecondary: {
			type: String,
			default: '',
		},
		tamanhoIconePrimary: {
			type: String,
			default: '24',
		},
		tamanhoIconeSecondary: {
			type: String,
			default: '24',
		},
		tamanhoIconeMenu: {
			type: String,
			default: '18',
		},
		outlined: {
			type: Boolean,
		},
		block: {
			type: Boolean,
		},
		disabled: {
			type: Boolean,
		},
	},
}
</script>
<style lang="stylus" scoped>

.texto-menu-interno, .texto-botao
	font-size (13 / 16)rem !important

.list-item-height
	min-height 0 !important

.v-list-item
	padding 0 10px !important

.v-list-item__icon
	margin auto 5px !important

.v-list-item--disabled
	cursor not-allowed !important
</style>
